// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { cloud16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-cloud': IconCloud;
    }
}

/**
 * The icon component for the 'cloud' icon
 */
export class IconCloud extends IconSvg {
    public constructor() {
        super(cloud16X16);
    }
}

registerIconSvg('icon-cloud', IconCloud);
export const iconCloudTag = 'nimble-icon-cloud';
